import { useCallback } from 'react';
import { isApiError } from '../api/client';
import { useAdminAuth } from '../contexts/AdminAuthContext';

/**
 * Wraps an admin API call so a signed-out (or expired) admin is sent back to
 * log in. Every error, that one included, still reaches the caller.
 */
export function useAdminCall(): <T>(run: () => Promise<T>) => Promise<T> {
  const { handleUnauthorized } = useAdminAuth();
  return useCallback(
    async <T,>(run: () => Promise<T>): Promise<T> => {
      try {
        return await run();
      } catch (e) {
        if (isApiError(e) && e.unauthorized) handleUnauthorized();
        throw e;
      }
    },
    [handleUnauthorized],
  );
}
